import Vue from 'vue';
// import store from '@/store/index';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import Devices from '../views/Devices.vue';
import User from '../views/User.vue';
import Cameras from '../views/Cameras.vue';
import LiveView from '../views/LiveView.vue';
import AddCamera from '../views/AddCamera.vue';
import ManualAddCamera from '../views/ManualAddCamera.vue';
import CameraSettings from '../views/CameraSettings.vue';
import ChangePassword from '../views/ChangePassword.vue';
import AddDevice from '../views/AddDevice.vue';
import AddOnvifCamera from '../views/AddOnvifCamera.vue';
import EditPassword from '../views/EditPassword.vue';
import LoginCreds from '../views/LoginCreds.vue';
import AppStats from '../views/AppStats.vue';

Vue.use(VueRouter);

const routes = [

  {
    path: '/',
    name: 'Login',
    component: Login,
    meta: { hideNav: true },
  },
  {
    path: '/auth/login/creds',
    name: 'LoginCreds',
    component: LoginCreds,
    meta: { hideNav: true },
  },
  {
    path: '/Cameras',
    name: 'Cameras',
    component: Cameras,
  },
  {
    path: '/Cameras/LiveView/:camera/:device',
    name: 'CameraView',
    component: LiveView,
    meta: { hideNav: true },

  },
  {
    path: '/Devices',
    name: 'Devices',
    component: Devices,
  },
  {
    path: '/Devices/camera/:camera',
    name: 'CameraSettings',
    component: CameraSettings,
    meta: { hideNav: true },
  },
  {
    path: '/user',
    name: 'User',
    component: User,
  },
  // {
  //   path: '/LiveView',
  //   name: 'LiveView',
  //   component: LiveView,
  //   meta: { hideNav: true },
  // },
  {
    path: '/AddCamera/:id',
    name: 'AddCamera',
    component: AddCamera,
    meta: { hideNav: true },
  },
  {
    path: '/ManuallyAddCamera/:device',
    name: 'ManuallyAddCamera',
    component: ManualAddCamera,
    meta: { hideNav: true },
  },
  {
    path: '/AddOnvifCamera/:camera/:device/:item',
    name: 'AddOnvifCamera',
    component: AddOnvifCamera,
    meta: { hideNav: true },
    props: true,
  },
  {
    path: '/ChangePassword',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: { hideNav: true },
  },
  {
    path: '/AddDevice',
    name: 'AddDevice',
    component: AddDevice,
    meta: { hideNav: true },
  },
  {
    path: '/Editpassword',
    name: 'EditPassword',
    component: EditPassword,
    meta: { hideNav: true },
  },
  {
    path: '/Stats',
    name: 'AppStats',
    component: AppStats,
    meta: { hideNav: true },
  },

];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,

});
router.beforeEach((to, from, next) => {
  if (to.name === 'LoginCreds' && !!localStorage.getItem('loggedIn') === false) {
    next();
    return;
  }

  if (to.name === 'Login' && !!localStorage.getItem('loggedIn') === true) {
    next({ name: 'Cameras' });
  }
  if (to.name === 'ChangePassword') {
    next();
  } else if (to.name !== 'Login' && !!localStorage.getItem('loggedIn') === false) {
    next({ name: 'Login' });
  } else next();
});

export default router;
